export default __webpack_public_path__ + "f6cc9c2399defe9bc50b1d57ad3795a4.png";